import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employee-navigation',
  templateUrl: './employee-navigation.component.html',
  standalone: false,
})
export class EmployeeNavigationComponent {
  private readonly route = inject(ActivatedRoute);

  readonly employeeId = Number(this.route.snapshot.paramMap.get('employeeId'));
}
